import { Button } from '@/components/ui/button'
import { LoaderCircle, Pause, Play } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import TextLoading from '@/components/ui/textLoading'

export const JudgmentReadingControl = ({
  playReading,
  pauseReading,
  playerReady,
  isPlaying,
  restartReading,
}) => {
  return (
    <div className="sticky bottom-0 left-0 right-0 p-4 bg-gray-100 dark:bg-gray-900 border mt-[100%] rounded">
      {playerReady ? (
        <div className=" flex justify-around items-center">
          {/* <Tooltip>
            <TooltipTrigger>
              <Button
                className="w-[50px] h-[50px] rounded"
                variant="outline"
                onClick={restartReading}
              >
                <RotateCcw />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <h5 className="font-semibold text-sm">Restart Judgment</h5>
            </TooltipContent>
          </Tooltip> */}

          <p className="text-sm font-semibold max-w-[75%]">
            Ready to announce the final verdict? Press play to broadcast it to everyone.
          </p>

          <Tooltip>
            <TooltipTrigger>
              <Button
                className="w-[50px] h-[50px] rounded"
                variant="outline"
                onClick={() => {
                  if (isPlaying) pauseReading()
                  else if (playerReady) playReading()
                }}
                disabled={!playerReady}
              >
                {playerReady ? (
                  isPlaying ? (
                    <Pause />
                  ) : (
                    <Play />
                  )
                ) : (
                  <LoaderCircle className="animate-spin h-4 w-8" />
                )}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <h5 className="font-semibold text-sm">{isPlaying ? 'Pause' : 'Play'} Judgment</h5>
            </TooltipContent>
          </Tooltip>
        </div>
      ) : (
        <div className="text-md font-bold text-center">
          <TextLoading text="Loading audio" />
        </div>
      )}
    </div>
  )
}
